import { trpc } from "../trpc";
interface Input {
  folderId?: string; // optional folderId for invalidating the folder assets query
}

export function useChangeChatbotOwner(input?: Input) {
  const { folderId } = input || {};
  const utils = trpc.useUtils();

  const { mutateAsync, isPending, error, isSuccess, isError } =
    trpc.chatbot.changeOwner.useMutation({
      onMutate: ({ chatbotId, newOwnerId }) => {
        utils.chatbot.list.cancel();

        utils.chatbot.list.setData({}, (old: any) => {
          if (!old?.data?.chatbots) {
            return old;
          }

          return {
            ...old,
            data: {
              ...old.data,
              chatbots: old.data.chatbots.map((chatbot: any) => {
                if (chatbot.id === chatbotId) {
                  return {
                    ...chatbot,
                    ownerZapierCustomuserId: newOwnerId,
                    owner: chatbot.owner
                      ? {
                          ...chatbot.owner,
                          id: newOwnerId,
                        }
                      : undefined,
                  };
                }
                return chatbot;
              }),
            },
          };
        });
      },

      onSettled: () => {
        utils.chatbot.list.invalidate();
        utils.permission.checkPermissions.invalidate();
        if (folderId) {
          utils.asset.getHydratedFolderAssets.invalidate({
            folderId,
          });
        }
      },
    });

  return {
    changeChatbotOwner: mutateAsync,
    error,
    isError,
    isLoading: isPending,
    isPending,
    isSuccess,
  };
}
